import { useContext } from 'react';
import FindClinicContext from '../contexts/FindClinicContext/FindClinicContext';

export const useFindClinicContext = () => {
  return useContext(FindClinicContext);
};
